import emailjs from 'emailjs-com';
import config from './config';
import toast from 'react-hot-toast';

export interface CompanyRegistrationData {
  companyName: string;
  companyWebsite: string;
  employeeCount: string;
  estimatedPlayers: string;
  contactName: string;
  contactEmail: string;
  additionalInfo?: string;
}

export const sendCompanyRegistrationEmail = async (
  formData: CompanyRegistrationData
): Promise<boolean> => {
  try {
    const templateParams = {
      // Required for template subject and content
      name: formData.contactName,
      title: 'New Company Registration - BreakRoom Cup',
      time: new Date().toLocaleTimeString(),
      message: `New company registration received from ${formData.companyName}`,
      // Registration form data
      company_name: formData.companyName,
      company_website: formData.companyWebsite,
      employee_count: formData.employeeCount,
      estimated_players: formData.estimatedPlayers,
      contact_name: formData.contactName,
      contact_email: formData.contactEmail,
      additional_info: formData.additionalInfo || 'None',
      submission_date: new Date().toLocaleString(),
    };

    console.log('Sending email via EmailJS with params:', templateParams);

    await emailjs.send(
      config.email.serviceId,
      config.email.templateId,
      templateParams,
      config.email.publicKey
    );

    console.log('✅ Email sent successfully via EmailJS');
    return true;
  } catch (error: any) {
    console.error('❌ Error sending email notification:', error);
    console.error('Error details:', {
      message: error?.message,
      status: error?.status,
      text: error?.text,
      response: error?.response,
    });

    // More specific error message for EmailJS errors
    let errorMessage = 'Failed to send registration email. Please try again later.';
    if (error?.text) {
      errorMessage = `Email sending failed: ${error.text}`;
    } else if (error?.message) {
      errorMessage = `Registration failed: ${error.message}`;
    }

    toast.error(errorMessage);
    return false;
  }
};

